import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: '400px' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">
          <div className="confirm-dialog">
            <div className="confirm-icon">
              <FiAlertTriangle />
            </div>
            <h3>{title || 'Confirm Delete'}</h3>
            <p>{message || 'Are you sure you want to delete this item? This action cannot be undone.'}</p>
            <div className="confirm-actions">
              <button className="btn btn-secondary" onClick={onClose} disabled={isLoading}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={onConfirm} disabled={isLoading}>
                {isLoading ? 'Deleting...' : 'Delete'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
